export const CONTRACT_CALL_INDEX =
  "[tx.contract_call.contract_id+tx.contract_call.function_name]"
